<h3 *ngIf="machineForm.controls.id.value">Edit Machine</h3>
<h3 *ngIf="!machineForm.controls.id.value">Add Machine</h3>

<div class="machine-edit-container">
  <form [formGroup]="machineForm" (ngSubmit)="onSubmit()">
    <input formControlName="id" type="hidden" />

    <mat-form-field class="machine-form-field">
      <mat-label>Serial Number</mat-label>
      <input
        matInput
        placeholder="Serial Number"
        formControlName="serialNumber"
        required
      />
      <mat-error
        *ngIf="machineForm.controls?.serialNumber?.hasError('required')"
      >
        serialNumber is <i>required</i>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="machine-form-field">
      <mat-label>Name</mat-label>
      <input matInput placeholder="Name" formControlName="name" required />
      <mat-error *ngIf="machineForm.controls?.name?.hasError('required')">
        Name is <i>required</i>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="machine-form-field">
      <mat-label>Customer</mat-label>
      <mat-select formControlName="customerId" required>
        <mat-option *ngFor="let customer of customers" [value]="customer.id">
          {{ customer.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="machine-form-field function-field">
      <mat-label>Function</mat-label>
      <mat-select formControlName="function" required>
        <mat-option *ngFor="let item of functions" [value]="item">
          {{ functonLabel[item] }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="machineForm.controls.function.hasError('required')">
        function is <i>required</i>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="machine-form-field">
      <mat-label>Operator</mat-label>
      <input matInput placeholder="Operator" formControlName="operator" />
    </mat-form-field>
    <mat-form-field class="machine-form-field year-field">
      <mat-label>Year</mat-label>
      <input matInput placeholder="Year" formControlName="year" type="number" />
    </mat-form-field>
    <mat-form-field class="machine-form-field">
      <mat-label>Type</mat-label>
      <input matInput placeholder="Type" formControlName="machineType" />
    </mat-form-field>
    <mat-form-field class="machine-form-field" appearance="fill">
      <mat-label>Labels</mat-label>
      <mat-chip-list
        #chipList
        aria-label="Label selection"
        formControlName="labels"
      >
        <mat-chip
          *ngFor="let label of this.machineForm.value.labels"
          (removed)="remove(label)"
        >
          {{ label.type }}:{{ label.code }}
          <button class="button-chip" matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <input
          placeholder="New label (type:label)..."
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-list>
    </mat-form-field>
    <mat-form-field class="machine-form-field">
      <ngx-mat-file-input
        formControlName="imageBin"
        accept="image"
      ></ngx-mat-file-input>
      <mat-hint>Image/logo [max {{ imgaMaxSize }} Mb]</mat-hint>
      <mat-error *ngIf="machineForm.controls.imageBin.hasError('maxSize')">
        size is more then <i>maxSize</i>
      </mat-error>
    </mat-form-field>
    <mat-checkbox
      *ngIf="machineForm.controls?.id"
      class="machine-form-field"
      formControlName="deleteImg"
      >Delete Img</mat-checkbox
    >

    <button
      mat-raised-button
      color="primary"
      type="reset"
      (click)="clear()"
      class="editActionButton"
    >
      Clear
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      class="editActionButton"
      [disabled]="!machineForm.valid"
    >
      Save
    </button>

    <mat-error>
      <span *ngIf="machineForm.errors?.serialNumberTaken">
        This serialNumber is already taken
      </span>
    </mat-error>
  </form>

  <!-- Useful during the dev

    <p>
        Form Status: {{ machineForm.status }}
        Form Value: {{ machineForm.value | json}}
        Form Errors: {{ machineForm.errors }}
    </p>
--></div>
